import { render, staticRenderFns } from "./Image2.vue?vue&type=template&id=6ef11990&"
import script from "./Image2.vue?vue&type=script&lang=js&"
export * from "./Image2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports